module.exports = __webpack_public_path__ + "assets/img/svip_icon.e20bfb9b.png";